import IndiaAmountForm from "./forms/IndiaAmountForm";
import IndiaBeneficiaryForm from "./forms/IndiaBeneficiaryForm";
import IndiaReviewForm from "./forms/IndiaReviewForm";
import { FormRegistryMap } from "../../shared/types";

export const indiaFormRegistry: FormRegistryMap = {
  amount: {
    bank_transfer: IndiaAmountForm,
    default: IndiaAmountForm,
  },
  beneficiary: {
    bank_transfer: IndiaBeneficiaryForm,
    default: IndiaBeneficiaryForm,
  },
  review: {
    bank_transfer: IndiaReviewForm,
    default: IndiaReviewForm,
  },
};
